import React, { useState, useEffect } from 'react';
import axios from 'axios';

const UploadDemo = () => {
  const [courses, setCourses] = useState([]);
  const [videos, setVideos] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [videoName, setVideoName] = useState('');
  const [lectureName, setLectureName] = useState('');
  const [duration, setDuration] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchCourses();
    fetchVideos();
  }, []);

  const fetchCourses = async () => {
    try {
      const response = await axios.get('https://schoolofservice.co.za/backend/fetch_courses.php');
      if (response.data.status === 'success') {
        setCourses(response.data.data);
      } else {
        setMessage('Failed to load courses.');
      }
    } catch (error) {
      setMessage('An error occurred while fetching courses.');
    }
  };

  const fetchVideos = async () => {
    try {
      const response = await axios.get('https://schoolofservice.co.za/backend/fetch_videos.php');
      if (response.data.status === 'success') {
        setVideos(response.data.data);
      } else {
        setMessage('Failed to load videos.');
      }
    } catch (error) {
      setMessage('An error occurred while fetching videos.');
    }
  };

  const extractYouTubeVideoID = (url) => {
    const match = url.match(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/.*[?&]v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    return match ? match[1] : null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!videoUrl || !selectedCourse || !videoName || !lectureName || !duration || !description || !image) {
        setMessage('Please provide all the required fields including an image.');
        return;
    }

    const videoId = extractYouTubeVideoID(videoUrl);
    if (!videoId) {
        setMessage('Invalid YouTube URL. Please provide a valid YouTube video link.');
        return;
    }

    const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}?controls=1&mute=1&rel=0`;
    const formData = new FormData();
    formData.append('videoUrl', embedUrl);
    formData.append('courseId', selectedCourse);
    formData.append('videoName', videoName);
    formData.append('lectureName', lectureName);
    formData.append('duration', duration);
    formData.append('description', description);
    formData.append('image', image);

    // Log the form data being sent
    for (let [key, value] of formData.entries()) {
        console.log(key, value);
    }

    try {
        const response = await axios.post('https://schoolofservice.co.za/backend/uploadDemo.php', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        if (response.data.status === 'success') {
            setMessage('Video link uploaded successfully.');
            fetchVideos();
        } else {
            setMessage(response.data.message || 'Failed to upload video link.');
        }
    } catch (error) {
        setMessage('An error occurred while uploading the video link.');
        console.error(error); // Log the error for debugging
    }
};

  return (
    <div>
      <h3>Upload Video Link</h3>
      {message && <div className="alert alert-info">{message}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Video URL</label>
          <input type="url" className="form-control" value={videoUrl} onChange={(e) => setVideoUrl(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Video Name</label>
          <input type="text" className="form-control" value={videoName} onChange={(e) => setVideoName(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Upload Image</label>
          <input type="file" className="form-control" accept="image/*" onChange={(e) => setImage(e.target.files[0])} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Lecture Name</label>
          <input type="text" className="form-control" value={lectureName} onChange={(e) => setLectureName(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Video Duration</label>
          <input type="text" className="form-control" value={duration} onChange={(e) => setDuration(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Video Description</label>
          <textarea className="form-control" rows="3" value={description} onChange={(e) => setDescription(e.target.value)} required></textarea>
        </div>
        <div className="mb-3">
          <label className="form-label">Select Course</label>
          <select className="form-select" value={selectedCourse} onChange={(e) => setSelectedCourse(e.target.value)} required>
            <option value="">Select Course</option>
            {courses.map((course) => (
              <option key={course.coursesID} value={course.coursesID}>{course.courseName}</option>
            ))}
          </select>
        </div>
        <button type="submit" className="btn btn-primary">Upload Video</button>
      </form>
    </div>
  );
};

export default UploadDemo;
